<template>
  <div class="charts-page">
    <div class="row topCardGrid">
      <sp-card :valor="total_analises_ultimoMes" :descricao="$t('empreenda.viabilidade.tooltipCard.ultimoMes')" :lgGrid="3" :mdGrid="3" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"/>
      <sp-card :valor="total_analises_ultimoSemestre" :descricao="$t('empreenda.viabilidade.tooltipCard.ultimoSemestre')" :lgGrid="3" :mdGrid="3" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"/>
      <sp-card :valor="total_analises_ultimoAno" :descricao="$t('empreenda.viabilidade.tooltipCard.ultimoAno')" :lgGrid="3" :mdGrid="3" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"/>
      <sp-card :valor="total_analises" :descricao="$t('empreenda.viabilidade.tooltipCard.desdeSempre')" :lgGrid="3" :mdGrid="3" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"/>
    </div>
    <div class="row">
      <div class="flex md12 xs12">
        <sp-360-panel :title="`${this.tabela.titulo} - ${this.subAtual}`" :tooltipOptions="tabela.topTooltipOptions"
        :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <div class="flex-box" >
            <div class="flex md4">
              <sp-map v-on:regiaoClicada="filtrarPorRegiao($event)" ref="mapa" id="" :habilitarAnimacaoClique="true"></sp-map>
            </div>
            <div class="flex md8">
              <div id="divFiltroTempo">
                <multiselect id="selectSegmentoTemporal"
                  name="selectTemporal"
                  :placeholder="$t('mainDashboard.filterTablePlaceholder')"
                  :value="corteTemporalEscolhido"
                  :options="corteTemporal"
                  :searchable="false"
                  :close-on-select="true"
                  :show-labels="false"
                  :allowEmpty="false"
                  v-model="corteTemporalEscolhido"
                  track-by="atributo"
                  label="label"
                  @input="updateSub" />
              </div>
              <sp360-data-table v-if="!tabela.tableDataSecao.data.length" id="tabelaLicPorSub" ref="licPorSub" :apiMode="false" :data="tabela.tableDataSubs.data"
                :fields="tabela.tableFieldsSubs" :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" :footerObj="footerGeral" />

              <sp360-data-table v-if="tabela.tableDataSecao.data.length" id="tabelaSecaoPorSub" ref="secaoPorSub" :apiMode="false" :data="tabela.tableDataSecao.data"
              :fields="tabela.tableFieldsSecao" :sortFunctions="tabela.sortFunctions" :perPage="tabela.itemsPerPage" :footerObj="footerSub" />

            </div>

          </div>
        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex lg12 md12 ">
        <sp-360-panel class="chart-widget" :title="tituloHBResultadoIntervalo" :tooltipOptions="tooltipOptionsHBResultadoIntervalo" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <sp360-chart ref="hbResultadoChart" class="lic-chart" v-bind:data="dadosHBResultadoIntervalo" :options="optionsHBResultadoIntervalo" type="vertical-bar" />
        </sp-360-panel>
      </div>
    </div>
    <div class="row">
      <div class="flex md6 xs12 ">
        <sp-360-panel class="chart-widget" :title="tituloHBEstabelecimentoIntervalo" :tooltipOptions="tooltipOptionsHBEstabelecimentoIntervalo" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <sp360-chart ref="hbEstabelecimentoChart" v-bind:data="dadosHBEstabelecimentoIntervalo" :options="optionsHBEstabelecimentoIntervalo" type="vertical-bar" />
        </sp-360-panel>
      </div>
      <div class="flex md6 xs12 ">
        <sp-360-panel class="chart-widget" :title="tituloLineSolicitacoesIntervalo" :tooltipOptions="tooltipOptionsLineSolicitacoesIntervalo" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <sp360-chart :data="dadosLineSolicitacoesIntervalo" type="line" class="chart" :options="optionsLineSolicitacoesIntervalo" />
        </sp-360-panel>
      </div>
    </div>
  </div>
</template>

<script>

import constantes from '@/utils/ConstantesGlobais'
import mapaDeCalor from '@/services/MapaDeCalor'
import MethGlob from '@/utils/MetodosGlobais'
import SpMap from '@/components/maps/360-maps/SPMap'
import _ from 'lodash'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import CorUtils from '@/utils/CorUtils'
import * as d3 from 'd3'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import SpCard from '@/components/ui/cards/SP360Card'
import Multiselect from 'vue-multiselect'
import * as am4core from '@amcharts/amcharts4/core'
import * as am4charts from '@amcharts/amcharts4/charts'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'

export default {
  name: 'analise-viabilidade',
  components: {
    Sp360Panel,
    SpMap,
    Sp360DataTable,
    Sp360Chart,
    SpCard,
    Multiselect,
  },
  data () {
    return {
      cores: CorUtils.getCoresMapa(),
      coresGraficoLinha: CorUtils.getSimpleVector(),
      tooltipOptionsHBResultadoIntervalo: {},
      tituloHBResultadoIntervalo: this.$t('empreenda.viabilidade.tituloBarChartResultadoIntervalo'),
      tituloHBEstabelecimentoIntervalo: '',
      tooltipOptionsLineSolicitacoesIntervalo: {},
      tooltipOptionsHBEstabelecimentoIntervalo: {},
      tituloLineSolicitacoesIntervalo: this.$t('empreenda.viabilidade.tituloLineSolicitacoesIntervalo'),
      dadosHBResultadoIntervalo: { datasets: null, labels: null },
      dadosLineSolicitacoesIntervalo: {},
      dadosHBEstabelecimentoIntervalo: { datasets: null, labels: null },
      optionsLineSolicitacoesIntervalo: {},
      optionsHBResultadoIntervalo: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 0,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: MethGlob.percentualLabelCallback(false, true, 'pie'),
        },
        scales: {
          xAxes: [{
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              callback: MethGlob.formataStringCallback(20),
            },
            display: true,
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('empreenda.viabilidade.eixoYBarChartResultadoIntervalo'),
            },
            ticks: {
              callback: (value) => MethGlob.thousandSeparator(value),
            },
          }],
        },
      },
      optionsHBEstabelecimentoIntervalo: {
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 20,
            bottom: 0,
          },
        },
        tooltips: {
          enabled: true,
          callbacks: MethGlob.percentualLabelCallback(false, true, 'pie'),
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('empreenda.viabilidade.eixoXBarChartEstabelecimentoIntervalo'),
            },
            ticks: {
              autoSkip: false,
              maxRotation: 45,
              callback: MethGlob.formataStringCallback(20),
            },
          }],
          yAxes: [{
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('empreenda.viabilidade.eixoYBarChartEstabelecimentoIntervalo'),
            },
            ticks: {
              callback: (value) => MethGlob.thousandSeparator(value),
            },
          }],
        },
      },
      footerTabelaMapa: '',
      secoesFiltradas: [],
      footerGeral: {},
      footerSub: {},
      subAtual: this.$t('mainDashboard.general'),
      ultimoClickIdSub: -1,
      ultimoClickNomeSub: '',
      corteTemporal: [
        {
          atributo: 'ULTIMO_MES',
          label: 'Último mês fechado',
        },
        {
          atributo: 'ULTIMO_SEMESTRE',
          label: 'Últimos 6 meses fechados',
        },
        {
          atributo: 'ULTIMO_ANO',
          label: 'Último ano',
        },
        {
          atributo: 'DESDE_SEMPRE',
          label: 'Desde o início',
        },
      ],
      corteTemporalEscolhido: {
        atributo: 'DESDE_SEMPRE',
        label: 'Desde o início',
      },
      total_analises: 0,
      total_analises_ultimoMes: 0,
      total_analises_ultimoSemestre: 0,
      total_analises_ultimoAno: 0,
      secaoPeriodo: [],
      porResultadoProcessado: {},
      porEstabelecimentoProcessado: {},
      solicitacaoIntervalo: [],
      tabela: {
        titulo: this.$t('empreenda.viabilidade.tituloAnaliseViabilidadeSub'),
        tableDataSubs: {
          'data': [],
        },
        tableDataSecao: {
          'data': [],
        },
        tableFieldsSubs: [
          {
            name: 'nome_subprefeitura',
            title: this.$t('empreenda.viabilidade.tableFields.subprefeitura'),
            // width: '20%',
          },
          {
            name: 'total_analises',
            sortField: 'total_analises',
            title: this.$t('empreenda.viabilidade.tableFields.analises'),
            callback: MethGlob.thousandSeparator,
            // width: '12%',
          },
          {
            name: 'percentual_analises',
            sortField: 'percentual_analises',
            title: this.$t('empreenda.viabilidade.tableFields.percAnalises'),
            callback: MethGlob.formataPercentual,
            // width: '12%',
          },
        ],
        tableFieldsSecao: [
          {
            name: 'ds_secao',
            title: this.$t('empreenda.viabilidade.tableFields.secao'),
            // width: '20% ',
          },
          {
            name: 'total_passivel',
            sortField: 'total_passivel',
            title: this.$t('empreenda.viabilidade.tableFields.passivel'),
            callback: MethGlob.thousandSeparator,
            // width: '12%',
          },
          {
            name: 'total_inconclusivo',
            sortField: 'total_inconclusivo',
            title: this.$t('empreenda.viabilidade.tableFields.inconclusivo'),
            callback: MethGlob.thousandSeparator,
            // width: '12%',
          },
          {
            name: 'total_analises',
            sortField: 'total_analises',
            title: this.$t('empreenda.viabilidade.tableFields.analises'),
            callback: MethGlob.thousandSeparator,
            // width: '12%',
          },
          {
            name: 'percentual_analises',
            sortField: 'percentual_analises',
            title: this.$t('empreenda.viabilidade.tableFields.percAnalises'),
            callback: MethGlob.formataPercentual,
            // width: '12%',
          },
        ],

        sortFunctions: {
          'total_passivel': MethGlob.ordenaTabelaParseInt,
          'total_inconclusivo': MethGlob.ordenaTabelaParseInt,
          'total_analises': MethGlob.ordenaTabelaParseInt,
          'percentual_analises': MethGlob.ordenaTabelaParseFloat,
        },

        topTooltipOptions: {
          content: this.$t('empreenda.viabilidade.tooltipViabilidadeSub'),
          placement: 'bottom',
        },
        itemsPerPage: 12,
      },
    }
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('empreenda/viabilidadePorSubPorPeriodoFechado', { intervalo: 'ULTIMO_MES', agrupamento: 'SECAO' }),
      this.$store.dispatch('empreenda/viabilidadePorSubPorPeriodoFechado', { intervalo: 'ULTIMO_SEMESTRE', agrupamento: 'SECAO' }),
      this.$store.dispatch('empreenda/viabilidadePorSubPorPeriodoFechado', { intervalo: 'ULTIMO_ANO', agrupamento: 'SECAO' }),
      this.$store.dispatch('empreenda/viabilidadePorSubPorPeriodoFechado', { intervalo: 'DESDE_SEMPRE', agrupamento: 'SECAO' }),
      this.$store.dispatch('empreenda/viabilidadeResultadoPorIntervalo', { intervalo: 'ULTIMO_MES', agrupamento: 'SECAO' }),
      this.$store.dispatch('empreenda/viabilidadeResultadoPorIntervalo', { intervalo: 'ULTIMO_SEMESTRE', agrupamento: 'SECAO' }),
      this.$store.dispatch('empreenda/viabilidadeResultadoPorIntervalo', { intervalo: 'ULTIMO_ANO', agrupamento: 'SECAO' }),
      this.$store.dispatch('empreenda/viabilidadeResultadoPorIntervalo', { intervalo: 'DESDE_SEMPRE', agrupamento: 'SECAO' }),
      this.$store.dispatch('empreenda/viabilidadeEstabelecimentoPorIntervalo', { intervalo: 'ULTIMO_MES' }),
      this.$store.dispatch('empreenda/viabilidadeEstabelecimentoPorIntervalo', { intervalo: 'ULTIMO_SEMESTRE' }),
      this.$store.dispatch('empreenda/viabilidadeEstabelecimentoPorIntervalo', { intervalo: 'ULTIMO_ANO' }),
      this.$store.dispatch('empreenda/viabilidadeEstabelecimentoPorIntervalo', { intervalo: 'DESDE_SEMPRE' }),
      this.$store.dispatch('empreenda/viabilidadeAberturaSolicitacaoPorIntervalo', {/* dataInicio, dataFim, */ agrupamento: 'SECAO' }),
    ])
      .then(
        (retorno) => {
          //{fonte: fonte, data: dataRef}
          this.fonte = retorno[0].data.sigla_orgao + '-' + retorno[0].data.fonte
          this.dataRef = new Date(retorno[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
          this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

          this.secaoPeriodo.porSub = new Array()
          this.secaoPeriodo.porSubNaoGeorref = new Array()
          this.secaoPeriodo.porResultado = new Array()
          this.secaoPeriodo.porEstabelecimento = new Array()
          for (let i = 0; i < 4; i++) {
            let o = this.corteTemporal[i]
            this.secaoPeriodo.porSub[o.atributo] = retorno[i].data.data.slice(0, 33)
            this.secaoPeriodo.porSubNaoGeorref[o.atributo] = retorno[i].data.data[33]
            this.secaoPeriodo.porResultado[o.atributo] = retorno[i + 4].data.data
            this.secaoPeriodo.porEstabelecimento[o.atributo] = retorno[i + 8].data.data
          }
          this.solicitacaoIntervalo = retorno[retorno.length - 1].data.data
          this.total_analises_ultimoMes = this.secaoPeriodo.porSub['ULTIMO_MES'][0].total_analises
          this.total_analises_ultimoSemestre = this.secaoPeriodo.porSub['ULTIMO_SEMESTRE'][0].total_analises
          this.total_analises_ultimoAno = this.secaoPeriodo.porSub['ULTIMO_ANO'][0].total_analises
          this.total_analises = this.secaoPeriodo.porSub['DESDE_SEMPRE'][0].total_analises
          this.processarHBResultadoIntervalo()
          this.processarHBEstabelecimentosIntervalo()
          this.updateSub()
          this.popularLineAberturaSolicitacao()
        }
      )
      .catch(
        (error) => {
          console.error(error)
        })
  },
  methods: {
    updateSub () {
      this.preencherTabelaSubs(this.secaoPeriodo.porSub[this.corteTemporalEscolhido.atributo])
      this.updateFooterText(this.secaoPeriodo.porSubNaoGeorref[this.corteTemporalEscolhido.atributo])
      if (this.ultimoClickIdSub > 0) {
        this.updateTableSecao(this.corteTemporalEscolhido.atributo)
      }
      this.popularHBResultadoIntervalo(this.corteTemporalEscolhido.atributo)
      this.popularHBEstabelecimentosIntervalo(this.corteTemporalEscolhido.atributo)
    },
    filtrarPorRegiao (id) {
      let idNum = MethGlob.idSvgToNumeric(id)
      if (this.ultimoClickIdSub != idNum) {
        this.$refs.mapa.limparClick(this.ultimoClickNomeSub)
        this.$refs.mapa.diminuirOpacidadeTodas()
        this.$refs.mapa.aumentarOpacidade(id)
        this.updateTableSecao(idNum)
        this.ultimoClickNomeSub = id
        this.ultimoClickIdSub = idNum
      } else {
        this.$refs.mapa.limparClick(id)
        this.$refs.mapa.aumentarOpacidadeTodas()
        this.hideSecaoTable()
        this.ultimoClickNomeSub = null
        this.ultimoClickIdSub = 0
      }
    },
    updateTableSecao (idSub) {
      this.tabela.tableDataSecao.data = this.secaoPeriodo.porSub[this.corteTemporalEscolhido.atributo][idSub].lista_analises
      let x = this.secaoPeriodo.porSub[this.corteTemporalEscolhido.atributo][idSub]
      let footer = {
        total_passivel: MethGlob.thousandSeparator(x.total_passivel),
        total_inconclusivo: MethGlob.thousandSeparator(x.total_inconclusivo),
        total_analises: MethGlob.thousandSeparator(x.total_analises),
        ds_secao: x.nome_subprefeitura,
      }
      this.footerSub = footer
      this.subAtual = this.secaoPeriodo.porSub[this.corteTemporalEscolhido.atributo][idSub].nome_subprefeitura
    },
    updateFooterText (dados) {
      let total_nao_georef = MethGlob.thousandSeparator(dados.total_analises, '.', null)
      let perc_nao_georef = MethGlob.formataPercentual(dados.percentual_analises)
      this.footerTabelaMapa = this.$t('empreenda.viabilidade.footerViabilidadeSub', { total_nao_ref: total_nao_georef, perc_nao_ref: perc_nao_georef })
    },
    hideSecaoTable () {
      this.tabela.tableDataSecao.data = []
      this.subAtual = this.$t('mainDashboard.general')
    },
    criarLegenda () {
      this.$refs.mapa.definirLegenda([this.cores.claro, this.cores.escuro],
        [this.$t('mainDashboard.legendaTitulo')])
    },
    preencherTabelaSubs (data) {
      data = _.cloneDeep(data)
      this.footerGeral = data.shift()
      this.footerGeral.total_analises = MethGlob.thousandSeparator(this.footerGeral.total_analises)

      this.tabela.tableDataSubs.data = []
      data = _.orderBy(data, ['total_analises'], ['desc'])

      data.forEach(obj => {
        let n = {}
        n.id_subprefeitura = obj.id_subprefeitura
        n.nome_subprefeitura = obj.nome_subprefeitura
        n.total_analises = obj.total_analises
        n.percentual_analises = obj.percentual_analises
        this.tabela.tableDataSubs.data.push(n)
      })

      this.pintarRegiao(this.tabela.tableDataSubs.data)
      this.$refs.mapa.setLegenda(data[data.length - 1].total_analises, data[0].total_analises, this.$t('empreenda.viabilidade.textoEixoLegenda.analisesRegiao'), 6)
      this.criarLegenda()
    },
    processarHBResultadoIntervalo () {
      let cores = _.reverse(CorUtils.getVetorCoresPorTom('medio'))

      this.tooltipOptionsHBResultadoIntervalo = {
        content: this.$t('empreenda.viabilidade.tooltipBarChartResultadoIntervalo'),
        placement: 'bottom',
      }

      let l = this.secaoPeriodo.porResultado['DESDE_SEMPRE']

      const uniqueTipoResultado = [...new Set(l.map(item => item.resultado_analise))]
      var dataSets = new Array()
      this.corteTemporal.forEach(ct => {
        dataSets[ct.atributo] = new Array()
        let cores_mutaveis = _.cloneDeep(cores)
        uniqueTipoResultado.forEach(ds => {
          let cor = cores_mutaveis.shift()
          let dataset = {
            keys: null,
            dataset: {
              backgroundColor: cor,
              data: null,
              label: ds,
              total: 0,
            },
          }
          dataSets[ct.atributo][ds] = dataset
        })
      })
      this.corteTemporal.slice(0).reverse().map(o => {
        let total = 0
        let agrupado = []
        let datasetProcessado = {}
        this.secaoPeriodo.porResultado[o.atributo].reduce((res, value) => {
          if (!res[value.ds_secao]) {
            res[value.ds_secao] = { ds_secao: value.ds_secao, total_analises: value.total_analises }
            agrupado.push(res[value.ds_secao])
          }
          res[value.ds_secao].total_analises += value.total_analises
          return res
        }, {})
        _.orderBy(agrupado, ['total_analises'], ['desc']).slice(0, 15).forEach(x => {
          datasetProcessado[x.ds_secao] = 0
        })
        datasetProcessado['Outros'] = 0
        let tiposResultado = new Array()
        uniqueTipoResultado.forEach(tipo => {
          tiposResultado[tipo] = _.clone(datasetProcessado)
        })

        this.secaoPeriodo.porResultado[o.atributo].forEach(obj => {
          let totalizador = 0
          if (Object.keys(datasetProcessado).includes(obj.ds_secao)) {
            tiposResultado[obj.resultado_analise][obj.ds_secao] += obj.total_analises
            totalizador = obj.total_analises
          } else {
            tiposResultado[obj.resultado_analise]['Outros'] += obj.total_analises
            totalizador = obj.total_analises
          }
          dataSets[o.atributo][obj.resultado_analise].keys = Object.keys(tiposResultado[obj.resultado_analise])
          dataSets[o.atributo][obj.resultado_analise].dataset.data = Object.values(tiposResultado[obj.resultado_analise])
          dataSets[o.atributo][obj.resultado_analise].dataset.total += totalizador
        })
      })
      this.porResultadoProcessado = dataSets
      this.popularHBResultadoIntervalo('DESDE_SEMPRE')
    },
    popularHBResultadoIntervalo (corte) {
      let labels = []
      let datasets = []
      Object.keys(this.porResultadoProcessado[corte]).forEach(y => {
        labels = this.porResultadoProcessado[corte][y].keys
        datasets.push(this.porResultadoProcessado[corte][y].dataset)
      })
      this.dadosHBResultadoIntervalo.datasets = _.orderBy(datasets, ['total'], ['desc'])
      this.dadosHBResultadoIntervalo.labels = labels
      this.$refs.hbResultadoChart.$refs.chart._data._chart.update()
      this.tituloHBResultadoIntervalo = this.$t('empreenda.viabilidade.tituloBarChartResultadoIntervalo') + ' - ' + this.corteTemporalEscolhido.label
    },
    popularLineAberturaSolicitacao () {
      this.tooltipLineSetor = { content: this.$t('emprego.tooltipAdmissaoSetor'), placement: 'bottom' }
      let chartData = {}
      let options = {}
      let datasets = []
      let cores = _.cloneDeep(this.cores)
      let Labels = ''
      let abertura = _.filter(this.solicitacaoIntervalo, function (o) { return o.tipo === 'Abertura' })
      let viabilidade = _.filter(this.solicitacaoIntervalo, function (o) { return o.tipo === 'Viabilidade de regularização' })
      abertura = _.orderBy(abertura, ['ano', 'mes'], ['desc', 'desc']).slice(0, 12)
      viabilidade = _.orderBy(viabilidade, ['ano', 'mes'], ['desc', 'desc']).slice(0, 12)
      Labels = _.map(abertura, (r) => {
        return MethGlob.mapeiaMesAbreviacao(parseInt(r.mes)).abrev + '/' + r.ano
      })

      _.forEach([abertura, viabilidade], d => {
        let total_solicitacoes = _.map(d, (n) => {
          return n.total_solicitacoes
        })

        let corDataset = this.coresGraficoLinha.shift()
        let dataSetAberturaViabilidade = {
          label: d[0].tipo,
          fill: false,
          backgroundColor: corDataset,
          borderColor: corDataset,
          data: _.reverse(total_solicitacoes),
          yAxisID: 'y-axis-1',
        }
        datasets.push(dataSetAberturaViabilidade)
      })

      chartData = {
        datasets: datasets,
        labels: _.reverse(Labels),
      }

      options = this.getOptionsLine(false, true)

      this.tooltipOptionsLineSolicitacoesIntervalo = {
        content: this.$t('empreenda.viabilidade.tooltipLineSolicitacoesIntervalo'),
        placement: 'bottom',
      }

      this.dadosLineSolicitacoesIntervalo = chartData
      this.optionsLineSolicitacoesIntervalo = options
    },
    getOptionsLine (percentual = true, milhar = false) {
      return {
        tooltips: {
          intersect: true,
          callbacks: this.tooltipsCallback(percentual, milhar),
        },
        scales: {
          xAxes: [{
            display: true,
            scaleLabel: {
              display: false,
            },
          }],
          yAxes: [{
            ticks: {
              callback: (value) => MethGlob.thousandSeparator(value),
            },
            id: 'y-axis-1',
            type: 'linear',
            position: 'left',
            display: true,
            scaleLabel: {
              display: true,
              labelString: this.$t('empreenda.viabilidade.textoEixoLegenda.solicitacoesLine'),
            },
          }],
        },
      }
    },
    tooltipsCallback (perc, separadorMilhar) {
      return {
        label: function (tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label + ': ' || ''
          if (separadorMilhar) { label += MethGlob.thousandSeparator(tooltipItem.yLabel) } else { label += tooltipItem.yLabel }
          if (label && perc) {
            label += '%'
          }
          return label
        },
      }
    },
    processarHBEstabelecimentosIntervalo () {
      this.tooltipOptionsHBEstabelecimentoIntervalo = {
        content: this.$t('empreenda.viabilidade.tooltipBarChartEstabelecimentoIntervalo'),
        placement: 'bottom',
      }

      let cores = _.reverse(CorUtils.getVetorCoresPorTom('medio'))
      let dadosTransformados = {}
      Object.keys(this.secaoPeriodo.porEstabelecimento).forEach(ct => {
        dadosTransformados[ct] = {}
        let cores_mutaveis = _.cloneDeep(cores)

        this.secaoPeriodo.porEstabelecimento[ct].forEach(x => {
          if (!dadosTransformados[ct][x.tipo_solicitacao]) {
            let cor = cores_mutaveis.shift()
            dadosTransformados[ct][x.tipo_solicitacao] = {
              keys: [],
              total: 0,
              dataset: {
                backgroundColor: cor,
                data: [],
                label: x.tipo_solicitacao,
              },
            }
          }
          dadosTransformados[ct][x.tipo_solicitacao].keys.push(x.risco)
          dadosTransformados[ct][x.tipo_solicitacao].dataset.data.push(x.total_estabelecimentos)
          dadosTransformados[ct][x.tipo_solicitacao].total += x.total_estabelecimentos
        })
        let soma = {}
        let conversao = []
        Object.keys(dadosTransformados[ct]).forEach(w => {
          for (let i = 0; i < dadosTransformados[ct][w].dataset.data.length; i++) {
            if (!soma[dadosTransformados[ct][w].keys[i]]) { soma[dadosTransformados[ct][w].keys[i]] = dadosTransformados[ct][w].dataset.data[i] } else { soma[dadosTransformados[ct][w].keys[i]] += dadosTransformados[ct][w].dataset.data[i] }
          }
        })
        Object.keys(soma).forEach(w => {
          conversao.push({ risco: w, total: soma[w] })
        })
        let arrayOrd = []
        _.orderBy(conversao, ['total'], ['desc']).forEach(w => {
          arrayOrd.push(w.risco)
        })
        Object.keys(dadosTransformados[ct]).forEach(w => {
          dadosTransformados[ct][w].keys = arrayOrd
          dadosTransformados[ct][w].dataset.data = _.orderBy(dadosTransformados[ct][w].dataset.data, [], ['desc'])
        })
      })

      this.porEstabelecimentoProcessado = dadosTransformados
      this.popularHBEstabelecimentosIntervalo('DESDE_SEMPRE')
    },
    popularHBEstabelecimentosIntervalo (corte) {
      let labels = []
      let datasets = []
      Object.keys(this.porEstabelecimentoProcessado[corte]).forEach(y => {
        labels = this.porEstabelecimentoProcessado[corte][y].keys
        datasets.push(this.porEstabelecimentoProcessado[corte][y].dataset)
      })
      this.dadosHBEstabelecimentoIntervalo.datasets = _.orderBy(datasets, ['total'], ['desc'])
      this.dadosHBEstabelecimentoIntervalo.labels = labels
      this.$refs.hbEstabelecimentoChart.$refs.chart._data._chart.update()
      this.tituloHBEstabelecimentoIntervalo = this.$t('empreenda.viabilidade.tituloBarChartEstabelecimentoIntervalo') + ' - ' + this.corteTemporalEscolhido.label
    },
    pintarRegiao (dados) {
      let c = CorUtils.getCoresMapa()
      dados = _.orderBy(dados, ['total_analises'], ['asc'])
      let colorScale = d3.scaleLinear()
        .domain([_.first(dados).total_analises, _.last(dados).total_analises])
        .range([c.claro, c.escuro])

      dados.forEach((element) => {
        let id = 'sub' + element.id_subprefeitura
        this.$refs.mapa.pintarRegiao(id, colorScale(element.total_analises))
      })
    },
  },
}
</script>

<style lang="scss">
.widget.chart-widget {
  .widget-body {
    height: 550px;
  }
}

.lic-chart{
  height: 700px;
}

#chartPieEstabelecimento {
  width: 100%;
  height: 500px;
}
.flex-box {
        display: flex;
}
</style>
